import { DndComplaintActionType } from "../actiontype/dnd-complaint.actiontype";
import ApiStatus from "../constants/api-status.enum";

const initialState = {
    dndComplaintSubmissionApiStatus: '',
    dndComplaintSubmissionResponse: ''
}

export default function(state = initialState, action) {
    switch(action.type) {
        case DndComplaintActionType.DND_COMPLAINT_SUBMISSION_LOADING:
        return {
            ...state,
            dndComplaintSubmissionApiStatus: ApiStatus.LOADING,
            dndComplaintSubmissionResponse: action.payload
        }
        case DndComplaintActionType.DND_COMPLAINT_SUBMISSION_SUCCESS:
        return {
            ...state,
            dndComplaintSubmissionApiStatus: ApiStatus.SUCCESS,
            dndComplaintSubmissionResponse: action.payload
        }
        case DndComplaintActionType.DND_COMPLAINT_SUBMISSION_ERROR:
        return {
            ...state,
            dndComplaintSubmissionApiStatus: ApiStatus.ERROR,
            dndComplaintSubmissionResponse: action.payload
        }
        default:
        return state;
    }
}